module.exports = __webpack_public_path__ + "img/k1.e0b8c4fc.jpg";